import { TCommentType } from '@entities/comment/model/types';

const EXCESS_TAB_ID = 'nav-excess-tab';
const EXTRA_WORKS_TAB_ID = 'nav-extra-works-tab';

const isTabSelected = (tabId: string): boolean => {
    const tabElement = document.getElementById(tabId);

    return tabElement?.getAttribute('aria-selected') === 'true';
};

export const getCommentTypeByActiveTab = (): TCommentType => {
    if (isTabSelected(EXTRA_WORKS_TAB_ID)) {
        return 'extraWorkComment';
    }

    if (isTabSelected(EXCESS_TAB_ID)) {
        return 'excessComment';
    }

    return 'positionComment';
};
